import React from 'react';
import {Route, Switch, Redirect} from 'react-router-dom';

import Financial_Final_Numbers from './components/Financial_Final_Numbers';

import ErrorBoundaryRoute from '../../../../containers/ErrorBoundaryRoute';
import UserRoles from "../../../../constants/UserRoles";

export default ({match, regions,roles}) => (

	<div>
		<Switch>
			{roles.some(role => [UserRoles.Admin, UserRoles.Financial].includes(role)) &&
			<ErrorBoundaryRoute exact path={`${match.url}`}>
				<Financial_Final_Numbers regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>
			}
		</Switch>
	</div>
);
